import { combineEpics } from 'redux-observable';
import { networkResetEpic } from 'data-layer-cr/dist/network';

/**
 * Register any epics needed for redux-observable here.
 */
const rootEpic = combineEpics(networkResetEpic);

export default rootEpic;
